<template>
  <a href="javascript:void(null);"
     class="match-bottom-card-outer"
     @click="matchItemClicked"
     v-if="item != null">
    <div>
      <img :src="item.imageUrl" style="width: 100%;height: auto;">
      <div class="match-bottom-card-bottom">
        <div>
          <div>{{item.title}}</div>
          <div>{{'比赛日期：' + itemDateText(item.matchStartTime) + '-' + itemDateText(item.matchEndTime)}}</div>
        </div>
        <div :class="[spanClass]">{{statusText}}</div>
      </div>
    </div>
  </a>
</template>

<script>
  export default {
    name: "HomeMatchCard",
    props: {
      item: {
        type: Object,
        value: null
      }
    },
    data() {
      return {
      }
    },
    mounted() {
    },
    computed: {
      status() {
        let matchStartTime = this.$moment(this.item.matchStartTime);
        let matchEndTime = this.$moment(this.item.matchEndTime);
        let now = this.$moment();
        now = this.$moment(now.format('yyyy-MM-DD'));

        if (!matchStartTime.isValid() || !matchEndTime.isValid()) {
          return 0;
        }

        if (now - matchStartTime < 0) {
          return 0;
        } else if (now - matchEndTime <= 0) {
          return 1;
        } else {
          return 2;
        }
      },

      statusText() {
        return this.status == 0 ? '未开始' : (this.status == 1 ? '进行中' : '已结束');
      },
      spanClass() {
        return this.status == 0 ? 'ready' : (this.status == 1 ? 'doing' : 'done');
      },
    },
    methods: {
      itemDateText(date) {
        let currentDate = this.$moment(date);
        if (currentDate.isValid()) {
          return  currentDate.format('yyyy.MM.DD');
        }
        return '';
      },
      matchItemClicked() {
        let item = this.item;
        let isGroup = item.isGroup;

        if (isGroup == 0) {
          let path = this.$router.resolve({
            name: 'matchDetailPage',
            params: {
              id: item.id,
            }
          });
          window.open(path.href, '_blank');

        } else if (isGroup == 1) {
          let path = this.$router.resolve({
            name: 'matchListPage',
            params: {
              id: item.id,
            }
          });
          window.open(path.href, '_blank');
        } else {
          let path = this.$router.resolve({
            name: 'matchGamesHomePage',
            params: {
              id: item.id,
            }
          });
          window.open(path.href, '_blank');
        }
      }
    }
  }
</script>

<style scoped>

  .match-bottom-card-outer {
    text-decoration: none;
    display: block;
    margin-top: 20px;
  }

  .match-bottom-card-outer > div {
    background-color: white;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 0 6px rgba(0,0,0, 0.3);
  }

  @media screen and (min-width: 768px){
    .match-bottom-card-outer {
      width: 40%;
    }
  }

  .match-bottom-card-bottom {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 15px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .match-bottom-card-bottom > div:first-child {
  }

  .match-bottom-card-bottom > div:first-child div {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    padding: 0;
    text-align: left;
  }

  .match-bottom-card-bottom > div:first-child div:first-child {
    color: #333;
    font-size: 1rem;
    font-weight: bold;
  }

  .match-bottom-card-bottom > div:first-child div:last-child {
    color: #999;
    font-size: 0.8rem;
    margin-top: 5px;
  }

  .match-bottom-card-bottom  div:last-child {
    color: white;
    font-size: 1rem;
    font-weight: bold;
    padding: 6px 0px;
    border-radius: 20px;
    text-align: center;
    min-width: 60px;
    align-items: flex-start;
    display: inline-block;
  }

  .match-bottom-card-bottom  div.ready {
    background-color: #fc1a34;
  }

  .match-bottom-card-bottom div.doing {
    background-color: rgb(227, 163, 77);
  }

  .match-bottom-card-bottom div.done {
    background-color: #cccccc;
  }

</style>




// WEBPACK FOOTER //
// src/components/matches/HomeMatchCard.vue